<template>
	<div>
		<div class="row">

			<div v-if="showTitle" class="col-md-12 mb-1 d-flex align-items-center justify-content-center">
				<div>
					<h5>{{ tabLabel }}</h5>
				</div>
				<div class="ml-auto">
					
					<el-checkbox border size="small" class="me-2" v-model="showchart" v-show="tabIndex < 2">
						Show Chart
					</el-checkbox>
								
					<el-popover trigger="click" size="small" ref="dropdown" v-model="dropdownVisible" popper-class="dropdown-filter">
						<el-button slot="reference" type="primary" plain size="small">
							<i class="fa fa-filter"></i> &nbsp; Filter
						</el-button>
						<div>
							<div class="ps-3 pe-3 pt-1 pb-1">
								<h5><i class="fa fa-filter"></i> &nbsp; Filter {{ tabLabel }}</h5>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="dropdown-filter-form">
								<el-form label-position="top" label-width="100px">
									<div class="row">
										<div class="col-md-6" v-if="tabName != 'oos'">
											<el-form-item label="Keagenan:">
												<el-select v-model="branch" clearable filterable placeholder="Keagenan" size="medium" style="width:100%;">
													<el-option v-for="item3 in keagenan.list" :key="item3.BranchId" :label="item3.BranchName" :value="item3.BranchId">
													</el-option>
												</el-select>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="tabName == 'oos'">
											<el-form-item label="Branch:">
												<el-select v-model="branchid" clearable filterable placeholder="Select" size="medium" style="width:100%;">
													<el-option v-for="item3 in branchdata.list" :key="item3.BranchId" :label="item3.BranchName" :value="item3.BranchId">
													</el-option>
												</el-select>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="tabName == 'oos'">
											<el-form-item label="Type">
												<el-radio-group v-model="oostype" size="small" name="oospso">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.oospso" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
									
										<div class="col-md-6" v-if="tabName != 'oos'">
											<el-form-item label="Locations">
												<el-radio-group v-model="detail1" size="small" name="detail1">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail1" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="tabName != 'oos'">
											<!--<ReportParamDateRange title="Date" v-model="date" />-->
											<el-form-item label="Date Range:">
												<div class="block" style="max-width: 250px;">
													<el-date-picker
													v-model="dateRange"
													type="daterange"
													align="right"
													size="small" 
													unlink-panels
													range-separator="-"
													start-placeholder="Start date"
													end-placeholder="End date"
													format="yyyy-MM-dd"
													value-format="yyyy-MM-dd"
													:picker-options="pickerOptions">
													</el-date-picker>
												</div>
											</el-form-item>
										</div>
										<div class="col-md-6" v-if="tabName != 'oos'">
											<el-form-item label="Periods">
												<el-radio-group v-model="period" size="small" name="period">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.period" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="is2024OrBelow && tabName != 'oos'">
											<el-form-item label="Area">
												<el-radio-group v-model="area" size="small" name="area">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="is2025OrAbove && tabName != 'oos'">
											<el-form-item label="Region">
												<el-radio-group v-model="region" size="small" name="region">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="tabName != 'oos'">
											<el-form-item label="Channel">
												<el-radio-group v-model="channel" size="small" name="channel">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.channel" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
																	
										<div class="col-md-6" v-if="tabName != 'oos'">
											<el-form-item label="PSO">
												<el-radio-group v-model="pso" size="small" name="pso">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.pso" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
										<div class="col-md-6" v-if="tabName != 'oos'">
											<el-form-item label="Items">
												<el-radio-group v-model="detail2" size="small" name="detail2">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail2" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
										<div class="col-md-6" v-if="tabIndex==0">
											<el-form-item label="Source">
												<el-radio-group v-model="source" size="small" name="source">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.source" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
									</div>
										
								</el-form>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="py-2 px-4">
								<div class="row">
									<div class="col-md-12 d-flex align-items-center">
										<div class="ml-auto">
											<el-button type="danger" size="medium" @click="closeDropdownForm" style="min-width:100px;"><i class="fa fa-close"></i> &nbsp; Close</el-button>
											<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="min-width:100px;"><i class="fa fa-check"></i> &nbsp; Apply Filter</el-button>
										</div>										
									</div>
								</div>
							</div>
						</div>
					</el-popover>

					<el-button class="ms-2" type="success" plain size="small" @click="exportExcel()" v-if="reportdata?.data?.length">
						<i class="fa fa-file-excel"></i> &nbsp; Export
					</el-button>
					<vue-excel-xlsx 
						v-show="false"
						ref="excelExport"
						:data="dataXLSX(reportdata)"
						:columns="columnXLSX(reportdata)"
						:file-name="tabLabel"
						:file-type="'xlsx'"
						:sheet-name="'sheet1'"
						>
						<i class="far fa-file-excel"></i>
					</vue-excel-xlsx>
					
				</div>
			</div>

			<div class="mb-3" v-if="!showTitle">          
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row">
								<div class="col-md-6" v-if="tabName != 'oos'">
									<el-form-item label="Keagenan:">
										<el-select v-model="branch" clearable filterable placeholder="Keagenan" size="medium" style="width:100%;">
											<el-option v-for="item3 in keagenan.list" :key="item3.BranchId" :label="item3.BranchName" :value="item3.BranchId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName == 'oos'">
									<el-form-item label="Branch:">
										<el-select v-model="branchid" clearable filterable placeholder="Select" size="medium" style="width:100%;">
											<el-option v-for="item3 in branchdata.list" :key="item3.BranchId" :label="item3.BranchName" :value="item3.BranchId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName == 'oos'">
									<el-form-item label="Type">
										<el-radio-group v-model="oostype" size="small" name="oospso">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.oospso" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6" v-if="tabName != 'oos'">
									<el-form-item label="Locations">
										<el-radio-group v-model="detail1" size="small" name="detail1">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail1" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName != 'oos'">
									<el-form-item label="Area">
										<el-radio-group v-model="area" size="small" name="area">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName != 'oos'">
									<el-form-item label="Channel">
										<el-radio-group v-model="channel" size="small" name="channel">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.channel" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6" v-if="tabName != 'oos'">
									<!--<ReportParamDateRange title="Date" v-model="date" />-->
									<el-form-item label="Date Range:">
										<div class="block">
											<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											size="small" 
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName != 'oos'">
									<el-form-item label="Periods">
										<el-radio-group v-model="period" size="small" name="period">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.period" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6" v-if="tabName != 'oos'">
									<el-form-item label="PSO">
										<el-radio-group v-model="pso" size="small" name="pso">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.pso" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName != 'oos'">
									<el-form-item label="Items">
										<el-radio-group v-model="detail2" size="small" name="detail2">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail2" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabIndex==0">
									<el-form-item label="Source">
										<el-radio-group v-model="source" size="small" name="source">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.source" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
								
							<div class="row mt-2">
								<div class="col-md-6">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			<div class="row" v-show="tabIndex < 2">
				<div class="col-md-3 mb-3" v-if="!showTitle">
					<el-checkbox v-model="showchart">Show Chart</el-checkbox>
				</div>

				<div class="col-md-4 mb-3" v-if="showchart">
					<el-radio-group v-model="charttype">
						<el-radio label="barchart" size="small">Bar Chart</el-radio>
						<el-radio label="linechart" size="small">Line Chart</el-radio>
					</el-radio-group>
				</div>

				<div class="col-md-3" v-if="showchart && charttype=='barchart' ">
					<el-checkbox v-model="stacked">Stacked</el-checkbox>
				</div>
				
			</div>

			<div class="mb-0" >
				<BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" />
				<LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
			</div>

			<div class="mt-0">
				<ReportResultTable :reportname="'LPGReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
			</div>

		</div>
	</div>
</template>

<script>

import LPG from '@/components/page/LPG.js'
import ReportResultTable from '@/views/pages/ReportResultTable2Custom.vue'
import { Rainbow, Rainbow2, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import { isShallow } from 'vue'

export default
{
	extends: LPG,
	props: ['tabIndex','tabName', 'tabLabel', 'showTitle'],
	components: { 
		//ReportParamSelect,
		ReportResultTable,
		LineChart,
		BarChart,
		//Loader,
	},

	data(){
		return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().mingguSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
			charttype: 'linechart', //barchart //linechart
			urlRequestParams: '',
			dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().mingguSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
			
			options: {
				period:[
					{ value: '', name: 'ALL' },
					{ value: 'daily', name: 'DAILY' },
					{ value: 'weekly', name: 'WEEKLY' },
					{ value: 'monthly', name: 'MONTHLY' },
					{ value: 'yearly', name: 'YEARLY' },
				],
				channel:[
					{ value: "", name: "ALL" }, 
					{ value: "channel", name: "BY CHANNEL" }, 
					{ value: "OTHER", name: "OTHER" }, 
					{ value: "STORE", name: "STORE" }, 
					{ value: "SPBU", name: "SPBU" }, 
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "area", name: "BY AREA" }, 
					{ value: "province", name: "BY PROVINCE" }, 
					{ value: "store", name: "BY BRANCH" }, 
				],
				detail2:[
					{ value: "", name: "ALL" }, 
					{ value: "item", name: "BY ITEM" }
				],
				pso:[
					{ value: "", name: "ALL" }, 
					{ value: "bypso", name: "BY PSO" },
					{ value: "PSO", name: "PSO" },
					{ value: "NONPSO", name: "NON PSO" },
				],
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				region:[
					{ value: "", name: "ALL" }, 
					//{ value: "region", name: "BY REGION", field: "RegionPertareId" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
					{ value: "6", name: "6" }, 
					{ value: "7", name: "7" }, 
				],
				source:[
					{ value: "", name: "ALL" }, 
					{ value: "source", name: "BY SOURCE" }, 
					{ value: "KEAGENAN", name: "KEAGENAN" }, 
					{ value: "VENDOR", name: "VENDOR" }, 
				],
				oospso:[
					{ value: "", name: "ALL" }, 
					{ value: "PSO", name: "PSO" },
					{ value: "NONPSO", name: "NON PSO" },
				],
			},

			branchdata:{ data:{}, list:[], types:[] },

			reportdata: [],
			chartdata: [],
			showchart: false,
			stacked: true,
			branch: this.$route.query.branch ? this.$route.query.branch : '',
			period: this.$route.query.period ? this.$route.query.period : 'daily',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			detail2: this.$route.query.detail2 ? this.$route.query.detail2 : '',
			area: this.$route.query.area ? this.$route.query.area : '',
			region: this.$route.query.region ? this.$route.query.region : '',
			channel: this.$route.query.channel ? this.$route.query.channel : '',
			pso: this.$route.query.pso ? this.$route.query.pso : 'bypso',
			source: this.$route.query.source ? this.$route.query.source : '',
			oostype : '',
			branchid : '',

			loading: {
				table: false,
				chart: false,
				isSuccess: false,
			},

			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			is2024OrBelow: false,
			is2025OrAbove: true,
			dropdownVisible: false,

		}
	},
	watch:{
		reportdata() { this.refreshChart(); },
		stacked() { this.refreshChart(); },
		dateRange(newValue, oldValue) {
			let yearCategory = this.getYearCategory(newValue);
			// && is2024OrBelow
			if(yearCategory == 1) {
				//year 2025 or above
				this.is2025OrAbove = true;
				this.is2024OrBelow = false;

				this.region = '';
				this.area = '';
				//this.salescharttype = 'saleschartregion'
			} else if(yearCategory == 2) {
				//year 2024 or below
				this.is2024OrBelow = true;
				this.is2025OrAbove = false;

				this.region = '';
				this.area = '';
				//this.salescharttype = 'saleschartarea'
			} else {
				//year mixed
				this.is2024OrBelow = true;
				this.is2025OrAbove = true;

				this.region = '';
				this.area = '';
				//this.salescharttype = 'saleschartall'
			} 
			
			//console.log('area: ' + this.area);
			//console.log('region: ' + this.region);
		},
	}, 
    mounted() {
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		
        this.$emit('childrenRoute');
		this.loadKeagenanList()
		//this.resumePilihan()

		if(this.tabName == 'oos')
			this.loadBranchList()
		
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		refreshChart() {
			let a = this.detail2 == "item" ? "ItemName" : "StatusPSO"
			let b = "Period"
			let c = Rainbow
			
			if (!this.period) {
				b = "Channel"
			}
			if (this.channel == "channel") {
				a = "Channel"
				c = Rainbow2
			}
			else if (this.tabIndex == 0 && this.source == "source") {
				a = "Source"
				c = Rainbow2
			}
			if (this.detail1 == "area") {
				a = "SalesArea"
			}
			else if (this.detail1 == "province") {
				a = "ProvinceName"
			}
			this.chartdata = this.processBarChart(this.reportdata.data, a, "", "TotalSalesExTax", false, b, "", 1000000, 2, c, false, false, false, this.stacked);
		},

		resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/lpg/sales?'
			else if (this.tabIndex == 1) this.urlRequestParams+='/lpg/sales2?'
			else if (this.tabIndex == 2) this.urlRequestParams+='/lpg/margin?'
			else if (this.tabIndex == 3) this.urlRequestParams+='/lpg/out-of-stock?'
			
			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')

			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&channel='+this.channel
			this.urlRequestParams+='&branch='+this.branch
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region='+this.region
			this.urlRequestParams+='&pso='+this.pso
			this.urlRequestParams+='&oostype='+this.oostype
			this.urlRequestParams+='&branchid='+this.branchid
			this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2

			if (this.tabIndex == 0) this.urlRequestParams+='&source='+this.source

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{ 
				this.reportdata = response.data;
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.table = false;
			})

		},

		async loadBranchList() {
			let url = Config().apiURL + "/v1/bright/branch?";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.list.length) {
					this.branchdata.list = result.data.list;
				}
			})
		},
		
		applyFilter() {
			this.dropdownVisible = false; 
			this.resumePilihan()
        },

		exportExcel() {
			this.$refs["excelExport"].exportExcel();
			//console.log('export excel');
		},

		closeDropdownForm() {
			this.dropdownVisible = false; 
		},
		
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>